import SearchIcon from 'assets/icons/searchIcon.svg';
import { observer } from 'mobx-react';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { ProgressSpinner } from 'primereact/progressspinner';
import './unconstrainedForecastSearchBar.module.scss';
import { useUnonstrainedForecastSearchBar } from './useUnconstrainedForecastSearchBar';

const ConceptSearchBar = () => {
  const {
    conceptSearchInput,
    serchfieldRef,
    isAllConceptLoading,
    handleFilterConceptSearch,
    isConceptDetailsLoading,
    filteredConceptsForSearch,
    isSearchButtonDisabled,
    handleEnterKeyDownConceptSearchField,
    handleConceptSearchInputChange,
    handleSearch,
  } = useUnonstrainedForecastSearchBar();

  return (
    <div className={'drugSearchBar'}>
      <Button
        outlined
        data-testid="drugSearchButton"
        className="searchIconButton"
        onClick={() => handleSearch(conceptSearchInput)}
        disabled={isSearchButtonDisabled()}
      >
        {!isAllConceptLoading && !isConceptDetailsLoading ? (
          <img className="searchIcon" src={SearchIcon} alt="search icon" />
        ) : (
          <ProgressSpinner
            style={{ width: '25px', height: '25px' }}
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration="1s"
          />
        )}
      </Button>
      <Divider className="divider" layout="vertical" />
      <div className={'searchBarRightSide'}>
        <AutoComplete
          onLoad={() => {
            if (serchfieldRef) serchfieldRef.current?.focus();
          }}
          ref={serchfieldRef}
          autoFocus
          onSelect={e => handleSearch(e.value)}
          minLength={1}
          delay={100}
          autoHighlight={true}
          disabled={isAllConceptLoading}
          onKeyDown={handleEnterKeyDownConceptSearchField}
          placeholder="Drug Concept & Form"
          style={{ flexGrow: 1 }}
          className={'searchField'}
          value={conceptSearchInput}
          completeMethod={handleFilterConceptSearch}
          suggestions={filteredConceptsForSearch} // Pass only concept strings here
          dropdownIcon={null}
          onChange={e => handleConceptSearchInputChange(e.value)}
        />
      </div>
    </div>
  );
};

export default observer(ConceptSearchBar);
